// import logo from './logo.svg';
import './App.css';
import {API_URL} from "./constant";
import React, { useEffect, useState } from 'react';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import allReducer from './reducer';
import { useLocalStorage } from './useLocalStorage';
// import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Redirect } from 'react-router';
import Home from "./page/Home";
import Cart from "./page/Cart";
import HistoryTransaction from "./page/HistoryTransaction";
import DetailHistoryTransaction from "./page/DetailHistoryTransaction";
import Profile from "./page/Profile";
import Login from './page/Login';
import Register from './page/Register';
import Item from './page/Item';
import Checkout from './page/Checkout';
import Address from './page/Address';
import Search from './page/Search';
import SearchPromo from './page/SearchPromo';
import Promo from './page/Promo';
import ReportBonus from './page/ReportBonus';
import ReportReward from './page/ReportReward';
import NetworkTree from './page/NetworkTree';
import MemberJoin from './page/MemberJoin';
import MemberRegister from './page/MemberRegister';
import Download from './page/Download';
import RepeatOrder from './page/RepeatOrder';
import PaymentInfo from './page/PaymentInfo';
import Invite from './page/Invite';
import Point from './page/Point';
import PointDetail from './page/PointDetail';
import FlashSalesOnline from './page/FlashSalesOnline';
import ForgotPassword from './page/ForgotPassword';
import ResetPassword from './page/ResetPassword';
import LandingPage from './page/replicate/LandingPage';
import ShopNow from './page/ShopNow';
import ShopPromo from './page/ShopPromo';
import ShopItem from './page/ShopItem';
import Qiana from './page/kol/Qiana'
import EditProfile from './page/EditProfile';
import ChallengeAchievement from './page/ChallengeAchievement';


let store = createStore(allReducer);

function App() {
  
  const [token, setToken] = useLocalStorage("token", "");
  const [regisType, setRegisType] = useState(0);
  const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={(props) => (
            token ? 
            (
              <Component {...props}/>
            ) 
            : 
            (
              <Redirect to={{
                    pathname: '/login',
                    state: { from: props.location }
                }}
              />
            )
        )}
    />
  )
  

  function getRegisType(){

    var requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    return fetch(`${API_URL}api/register/type`, requestOptions)
    .then(response => response.json())
    .catch(error => console.log('error', error))
  }

  async function initRegisType(){
    let response = await getRegisType();
    if(response && response.status == 200){
      setRegisType(response.data.Value);
    }else{

    }
  }

  useEffect(()=>{
    initRegisType();
  },[])

  // let isLogged = false;
  return (
    <div className="container" id="container">
      <Provider store={store}>
        <Router>
          <Switch>
            <Route path="/" exact component={Home}/>
            <Route path="/forgotpassword" exact component={ForgotPassword}/>
            <Route path="/reset" exact component={ResetPassword}/>
            <Route path="/download" exact component={Download}/>
            <Route path="/search" exact component={Search}/>
            <Route path="/searchpromo" exact component={SearchPromo}/>
            <Route path="/RepeatOrder" component={RepeatOrder}/>
            <Route path="/memberjoin/:sponsorid?" component={MemberJoin}/>
            <Route path="/shopnow/:sponsorid?" component={ShopNow}/>
            <Route path="/shopitem/:sponsorid?" component={ShopItem}/>
            <Route path="/shoppromo/:sponsorid?" component={ShopPromo}/>
            <Route path="/memberregister/:sponsorid" exact component={MemberRegister}/>
            {/* <Route path="/promo/:promoid" exact component={Promo}/> */}
            <Route path="/item/:itemid" exact component={Item}/>
            <Route path="/detailhistory/:id" exact component={DetailHistoryTransaction}/>
            <Route path="/paymentinfo/:id" exact component={PaymentInfo} />
            <Route path="/PointDetail/:code" exact component={ token? PointDetail : Login} />
            <PrivateRoute path="/editprofile" component={EditProfile} />
            <PrivateRoute path="/promo/:promoid" component={Promo} />
            <PrivateRoute path="/cart" component={Cart} />
            <PrivateRoute path="/history" component={HistoryTransaction} />
            <PrivateRoute path="/address" component={Address} />
            <PrivateRoute path="/bcc" component={FlashSalesOnline} />
            <PrivateRoute path="/Profile" component={Profile} />
            <PrivateRoute path="/ChallengeAchievement" component={ChallengeAchievement} />
            <PrivateRoute path="/ReportBonus" component={ReportBonus} />
            <PrivateRoute path="/ReportReward" component={ReportReward} />
            <PrivateRoute path="/NetworkTree" component={NetworkTree} />
            <PrivateRoute path="/Invite" component={Invite} />
            <PrivateRoute path="/Point" component={Point} />
            <PrivateRoute path="/checkout" component={Checkout} />
            <Route path="/login" exact>
              {!token ? <Login/> : <Redirect to="/"/>}
            </Route>
            <Route path="/signup" exact>
              {!token ? (regisType == 0 ? <Register /> : < MemberJoin/>) : <Redirect to="/"/>}
            </Route>
            <Route path="/:id" exact component={LandingPage}/>
            <Route path="/:id/:name" exact component={Qiana}/>
          </Switch>
        </Router>
      </Provider>
    </div>
  );
}

export default App;
